<template>
    <div class="o-google-maps">
        <GmapMap
            ref="map"
            :center="center"
            :options="options"
            :zoom="zoom"
            class="google-maps-map"
        />
        <AButton
            :text="$t('ui.back-to-indoors')"
            theme="white"
            class="gmap-button"
            @onClick="onBackIndoors"
        >
            <template #left>
                <img src="../../../assets/images/icons/gmap-button-icon.svg">
            </template>
        </AButton>
    </div>
</template>

<script>
import { gmapApi } from 'vue2-google-maps';
import { mapGetters } from "vuex";
import { parseDirectionsUrl } from './google-maps-helper.js'

import AButton from '../../atoms/a-button/a-button';

export default {
    name: 'OGoogleMaps',
    props: {
        origin: {
            type: [Object,String],
            default: () => ({})
        },
        destination: {
            type: [Object,String],
            default: () => ({})
        },
        strokeColor: {
            type: String,
            default: '#666666'
        },
    },
    components: {
        AButton
    },
    data() {
        return {
            center: {
                lat: 45.508,
                lng: -73.587
            },
            options: {
                disableDefaultUI: true
            },
            mapEngine: 'road',
            panel: {},
            zoom: 12,
            url: '',
            travelMode: 'WALKING',
            directionsService: null,
            directionsDisplay: null,
            googleMapReady: false
        }
    },
    computed: {
        ...mapGetters([
            't',
            'getMapConfigProp',
            'getDenormalisedObjectById'
        ]),
        google: gmapApi,
        directionsRendererOptions(){
            const lineSymbol = {
                path: this.google.maps.SymbolPath.CIRCLE,
                fillOpacity: 1,
                scale: 3
            };

            const polylineOptionsActual = new this.google.maps.Polyline({
                strokeColor: this.strokeColor,
                //strokeWeight: 5,
                strokeOpacity: 0,
                icons: [{
                    icon: lineSymbol,
                    offset: '0',
                    repeat: '10px'
                }],
            })

            return {
                map: this.map,
                suppressMarkers: this.originIconSrc || this.destinationIconSrc,
                polylineOptions: polylineOptionsActual
            }
        },
        start() {
            return this.origin ? this.origin : parseDirectionsUrl(this.url).origin
        },
        end() {
            return this.destination ? this.destination : parseDirectionsUrl(this.url).destination
        },
        item() {
            return this.getDenormalisedObjectById(this.$route.params.itemId);
        },
        originIconSrc() {
            return this.getMapConfigProp('step_icons.start_step_icon') || '';
        },
        destinationIconSrc() {
            return this.t(this.item, 'icon') || '';
        }
    },
    mounted() {
        this.$refs.map && this.$refs.map.$mapPromise.then((map) => {
            this.initMap(map);
        })
    },
    methods: {
        initMap(map) {
            this.map = map

            map.setOptions({
                styles:[
                    {
                        featureType: 'poi',
                        stylers: [{visibility: 'off'}]
                    },
                    {
                        featureType: 'transit',
                        elementType: 'labels.icon',
                        stylers: [{visibility: 'off'}]
                    }
                ]
            })

            this.directionsService = new this.google.maps.DirectionsService();
            this.directionsDisplay = new this.google.maps.DirectionsRenderer(this.directionsRendererOptions);

            this.directionsDisplay.setMap(map)
            this.panel && this.directionsDisplay.setPanel(this.panel);

            this.googleMapReady = true;
            this.calcDirections();
        },
        calcDirections() {

            const request = {
                origin: this.start,
                destination: this.end,
                travelMode: this.travelMode,
                provideRouteAlternatives:false
            }

            this.directionsService.route(request, this.renderDirections);
        },
        renderDirections(response, status) {
            if (status == 'OK') {
                this.directionsDisplay.setDirections(response);

                this.originIconSrc && this.makeMarker( this.start, this.makeIcon(this.originIconSrc), "title" );
                this.destinationIconSrc && this.makeMarker( this.end, this.destinationIconSrc, "title" );
            }
        },
        makeIcon(url){
            return {
                url,
                scaledSize: new google.maps.Size(100,100),
                anchor: { x: 30, y: 100 },
            }
        },
        makeMarker( position, icon, title ) {
            new this.google.maps.Marker({
                position: position,
                map: this.map,
                icon: icon,
                title: title
            })
        },
        onBackIndoors() {
            this.$emit('onBackIndoors');
        }
    }
}
</script>

<style lang="scss" src="./theme.scss" />
